import API_BASE from "./config";
import { generateAssistantResponse } from "./assistantLogic";

export async function sendAssistantMessage({ message, records, vehicleProfile, currentMileage }) {
  const payload = {
    message,
    records: records || [],
    vehicleProfile: vehicleProfile || null,
    currentMileage: currentMileage || 0,
  };

  try {
    const response = await fetch(`${API_BASE}/api/assistant`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Assistant API error: ${response.status}`);
    }

    const data = await response.json();

    if (!data || typeof data.intent !== "string" || typeof data.text !== "string") {
      throw new Error("Assistant API returned invalid data");
    }

    return {
      intent: data.intent || "fallback",
      text: data.text || "I’m sorry, I couldn’t process that.",
      recordDraft: data.recordDraft || null,
      reminderDraft: data.reminderDraft || null,
      issueDraft: data.issueDraft || null,
      recordsFound: data.recordsFound || [],
      suggestions: data.suggestions || [],
    };
  } catch (error) {
    console.error("Assistant service failed, using local fallback:", error);
    return generateAssistantResponse(message, records || [], vehicleProfile, currentMileage);
  }
}
